export const IconBook = () => (
  <svg
    className='mr-1' width='24' height='24' viewBox='0 0 24 24' fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12 21L11.8999 20.8499C11.2053 19.808 10.858 19.287 10.3991 18.9098C9.99286 18.5759 9.52476 18.3254 9.02161 18.1726C8.45325 18 7.82711 18 6.57482 18H5.2C4.07989 18 3.51984 18 3.09202 17.782C2.71569 17.5903 2.40973 17.2843 2.21799 16.908C2 16.4802 2 15.9201 2 14.8V6.2C2 5.07989 2 4.51984 2.21799 4.09202C2.40973 3.71569 2.71569 3.40973 3.09202 3.21799C3.51984 3 4.07989 3 5.2 3H5.6C7.84021 3 8.96031 3 9.81596 3.43597C10.5686 3.81947 11.1805 4.43139 11.564 5.18404C12 6.03968 12 7.15979 12 9.4M12 21V9.4M12 21L12.1001 20.8499C12.7947 19.808 13.142 19.287 13.6009 18.9098C14.0071 18.5759 14.4752 18.3254 14.9784 18.1726C15.5467 18 16.1729 18 17.4252 18H18.8C19.9201 18 20.4802 18 20.908 17.782C21.2843 17.5903 21.5903 17.2843 21.782 16.908C22 16.4802 22 15.9201 22 14.8V6.2C22 5.07989 22 4.51984 21.782 4.09202C21.5903 3.71569 21.2843 3.40973 20.908 3.21799C20.4802 3 19.9201 3 18.8 3H18.4C16.1598 3 15.0397 3 14.184 3.43597C13.4314 3.81947 12.8195 4.43139 12.436 5.18404C12 6.03968 12 7.15979 12 9.4'
      stroke='white' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'
    />
  </svg>
)
export const IconLayout = () => (
  <svg
    width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'
    className='d-block mx-auto'
  >
    <rect width='48' height='48' rx='24' fill='#ECFBFF' />
    <path
      d='M14.25 20.25H33.75M14.25 21H33.75M17.25 26.25H23.25M17.25 28.5H20.25M16.5 31.5H31.5C32.7426 31.5 33.75 30.4926 33.75 29.25V18.75C33.75 17.5074 32.7426 16.5 31.5 16.5H16.5C15.2574 16.5 14.25 17.5074 14.25 18.75V29.25C14.25 30.4926 15.2574 31.5 16.5 31.5Z'
      stroke='#6B7280'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const IconEducation = () => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M11.7399 3.65558C11.9047 3.58356 12.0921 3.58356 12.257 3.65558C15.4591 5.05466 18.494 6.76495 21.3233 8.74815C21.528 8.89166 21.6315 9.14048 21.589 9.38688C21.5464 9.63327 21.3655 9.83296 21.1244 9.89949C20.5347 10.0623 19.95 10.2376 19.3706 10.4245C17.019 11.1829 14.7553 12.1371 12.5987 13.2681L12.5958 13.2695C12.4981 13.3208 12.4005 13.3725 12.3032 13.4245C12.113 13.5261 11.8847 13.5261 11.6945 13.4245C11.5962 13.372 11.4977 13.3198 11.399 13.2681C10.3326 12.7089 9.24003 12.1928 8.12359 11.7223V11.5297C8.12359 11.4166 8.18164 11.3163 8.27146 11.2618C9.56746 10.4767 10.9043 9.75222 12.278 9.0924C12.5995 8.93797 12.7349 8.55216 12.5805 8.23066C12.4261 7.90916 12.0403 7.77372 11.7188 7.92814C10.3073 8.60613 8.93373 9.35049 7.60221 10.1572C7.21182 10.3937 6.94938 10.7808 6.86305 11.2144C6.12691 10.9312 5.38109 10.6675 4.6262 10.424C4.04685 10.2372 3.46216 10.0623 2.87243 9.89948C2.6314 9.83295 2.45043 9.63326 2.40788 9.38687C2.36533 9.14047 2.46883 8.89165 2.67358 8.74814C5.5029 6.76494 8.53774 5.05466 11.7399 3.65558Z'
      fill='#094E7F'
    />
    <path
      d='M12.9118 14.5637C15.0119 13.4416 17.2182 12.493 19.5119 11.7369C19.6274 12.9552 19.7012 14.1855 19.7318 15.4265C19.7384 15.6928 19.5808 15.9357 19.335 16.0383C16.88 17.0633 14.5449 18.3184 12.3565 19.7768C12.1396 19.9213 11.8571 19.9213 11.6403 19.7768C9.45193 18.3184 7.11677 17.0633 4.66176 16.0383C4.41598 15.9357 4.25841 15.6928 4.26497 15.4265C4.29555 14.1854 4.36936 12.955 4.48497 11.7366C5.27801 11.998 6.06061 12.2825 6.83199 12.5891V13.683C6.44593 13.9063 6.18619 14.3237 6.18619 14.8018C6.18619 15.2283 6.39292 15.6065 6.71163 15.8417C6.63455 16.1695 6.52048 16.4902 6.3694 16.7973C6.7592 16.9813 7.14566 17.1712 7.52868 17.3669C7.74682 16.9232 7.90498 16.4575 8.00316 15.9821C8.45466 15.7808 8.76939 15.3281 8.76939 14.8018C8.76939 14.3237 8.50965 13.9063 8.12359 13.683V13.1278C9.13224 13.5685 10.1203 14.0478 11.0858 14.5637C11.6563 14.8685 12.3413 14.8685 12.9118 14.5637Z'
      fill='#094E7F'
    />
    <path
      d='M5.50787 17.9983C5.86877 17.6374 6.15607 17.2309 6.3694 16.7973C6.7592 16.9813 7.14566 17.1712 7.52868 17.3669C7.25438 17.9247 6.88507 18.4477 6.42116 18.9116C6.16896 19.1638 5.76007 19.1638 5.50787 18.9116C5.25567 18.6594 5.25567 18.2505 5.50787 17.9983Z'
      fill='#094E7F'
    />
  </svg>
)

export const IconUser = () => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd' clipRule='evenodd'
      d='M18.818 14.1235C18.2016 13.4088 17.1428 13.4456 16.3149 13.8987C15.0338 14.6 13.5635 14.9986 12 14.9986C10.4365 14.9986 8.96618 14.6 7.68505 13.8987C6.85717 13.4456 5.79841 13.4088 5.182 14.1235C3.82222 15.7 3 17.7533 3 19.9986V20.9986C3 22.1032 3.89543 22.9986 5 22.9986H19C20.1046 22.9986 21 22.1032 21 20.9986V19.9986C21 17.7533 20.1778 15.7 18.818 14.1235Z'
      fill='#094E7F'
    />
    <path
      d='M17 6C17 8.76142 14.7614 11 12 11C9.23858 11 7 8.76142 7 6C7 3.23858 9.23858 1 12 1C14.7614 1 17 3.23858 17 6Z'
      fill='#094E7F'
    />
  </svg>
)

export const IconUserGreen = () => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd' clipRule='evenodd'
      d='M18.818 14.1235C18.2016 13.4088 17.1428 13.4456 16.3149 13.8987C15.0338 14.6 13.5635 14.9986 12 14.9986C10.4365 14.9986 8.96618 14.6 7.68505 13.8987C6.85717 13.4456 5.79841 13.4088 5.182 14.1235C3.82222 15.7 3 17.7533 3 19.9986V20.9986C3 22.1032 3.89543 22.9986 5 22.9986H19C20.1046 22.9986 21 22.1032 21 20.9986V19.9986C21 17.7533 20.1778 15.7 18.818 14.1235Z'
      fill='#278015'
    />
    <path
      d='M17 6C17 8.76142 14.7614 11 12 11C9.23858 11 7 8.76142 7 6C7 3.23858 9.23858 1 12 1C14.7614 1 17 3.23858 17 6Z'
      fill='#278015'
    />
  </svg>
)

export const IconFlag = () => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd' clipRule='evenodd'
      d='M1.97639 2.39844C2.40346 2.39844 2.74966 2.74464 2.74966 3.17171V3.72786L4.64488 3.25406C6.97288 2.67206 9.43227 2.94203 11.5786 4.01518L11.6896 4.07071C13.4694 4.9606 15.5049 5.19836 17.4418 4.7426L20.6479 3.98823C20.8921 3.93076 21.1491 3.99537 21.3371 4.16154C21.5251 4.3277 21.6208 4.57476 21.5938 4.82422C21.405 6.56701 21.3081 8.33761 21.3081 10.1311C21.3081 11.9396 21.4066 13.7248 21.5985 15.4816C21.6409 15.8699 21.3871 16.2288 21.0069 16.3183L17.796 17.0738C15.5069 17.6124 13.1014 17.3314 10.998 16.2797L10.8869 16.2242C9.07084 15.3162 6.98981 15.0877 5.01997 15.5802L2.74966 16.1478V21.7302C2.74966 22.1572 2.40346 22.5034 1.97639 22.5034C1.54933 22.5034 1.20312 22.1572 1.20312 21.7302V3.17171C1.20312 2.74464 1.54933 2.39844 1.97639 2.39844Z'
      fill='#094E7F'
    />
  </svg>
)
export const IconPick = () => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd' clipRule='evenodd'
      d='M17.3033 5.1967C14.3744 2.26777 9.62563 2.26777 6.6967 5.1967C3.76777 8.12563 3.76777 12.8744 6.6967 15.8033C6.98959 16.0962 6.98959 16.5711 6.6967 16.864C6.40381 17.1569 5.92893 17.1569 5.63604 16.864C2.12132 13.3492 2.12132 7.65076 5.63604 4.13604C9.15076 0.62132 14.8492 0.62132 18.364 4.13604C20.1211 5.89321 21 8.19775 21 10.4998C21 10.9141 20.6642 11.2498 20.25 11.2499C19.8358 11.2499 19.5 10.9141 19.5 10.4999C19.5 8.57933 18.7679 6.66128 17.3033 5.1967ZM15.182 7.31802C13.4246 5.56066 10.5754 5.56066 8.81802 7.31802C7.06066 9.07538 7.06066 11.9246 8.81802 13.682C9.11091 13.9749 9.11091 14.4497 8.81802 14.7426C8.52513 15.0355 8.05025 15.0355 7.75736 14.7426C5.41421 12.3995 5.41421 8.60051 7.75736 6.25736C10.1005 3.91421 13.8995 3.91421 16.2426 6.25736C17.414 7.42877 18 8.96558 18 10.4999C18 10.9141 17.6642 11.2499 17.25 11.2499C16.8358 11.2499 16.5 10.9142 16.5 10.4999C16.5 9.34715 16.0608 8.19683 15.182 7.31802ZM11.5484 8.63179C11.8602 8.54824 12.1905 8.67359 12.3684 8.94299L17.5955 16.8599C17.7627 17.113 17.7609 17.4419 17.591 17.6932C17.421 17.9445 17.1165 18.0687 16.8193 18.0079L14.722 17.5787L15.7668 21.4777C15.874 21.8778 15.6365 22.289 15.2364 22.3963C14.8363 22.5035 14.4251 22.266 14.3179 21.8659L13.2732 17.967L11.6717 19.3872C11.4447 19.5884 11.1189 19.6332 10.8461 19.5005C10.5733 19.3678 10.4073 19.0839 10.4254 18.7811L10.9939 9.3113C11.0132 8.98905 11.2366 8.71534 11.5484 8.63179Z'
      fill='#094E7F'
    />
  </svg>
)

export const IconDown = () => (
  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M10.7778 13.8872H17M17 13.8872V7.66493M17 13.8872L10.7778 7.66493L7.66667 10.776L3 6.10938'
      stroke='#EF444A' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'
    />
  </svg>
)

export const IconUp = () => (
  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M10.7778 6.10938H17M17 6.10938V12.3316M17 6.10938L10.7778 12.3316L7.66667 9.22049L3 13.8872'
      stroke='#26A316' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'
    />
  </svg>
)

export const IconBookActive = () => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M10.7061 5.01651C9.30725 4.12106 7.64379 3.60156 5.85998 3.60156C4.80931 3.60156 3.79926 3.78189 2.86004 4.11386C2.5834 4.21164 2.39844 4.47318 2.39844 4.76659V17.9204C2.39844 18.1452 2.50752 18.3559 2.69102 18.4857C2.87451 18.6154 3.10956 18.6481 3.32145 18.5732C4.11454 18.2929 4.96866 18.14 5.85998 18.14C7.70153 18.14 9.38913 18.7929 10.7061 19.8807V5.01651Z'
      fill='#094E7F'
    />
    <path
      d='M12.0907 19.8807C13.4077 18.7929 15.0953 18.14 16.9369 18.14C17.8282 18.14 18.6823 18.2929 19.4754 18.5732C19.6873 18.6481 19.9224 18.6154 20.1059 18.4857C20.2894 18.3559 20.3984 18.1452 20.3984 17.9204V4.76659C20.3984 4.47318 20.2135 4.21164 19.9368 4.11386C18.9976 3.78189 17.9876 3.60156 16.9369 3.60156C15.1531 3.60156 13.4896 4.12106 12.0907 5.01651V19.8807Z'
      fill='#094E7F'
    />
  </svg>
)
export const IconDel = () => (
  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M12.2837 7.5L11.9952 15M8.00481 15L7.71635 7.5M16.023 4.82547C16.308 4.86851 16.592 4.91456 16.875 4.96358M16.023 4.82547L15.1332 16.3938C15.058 17.3707 14.2434 18.125 13.2637 18.125H6.73631C5.75655 18.125 4.94198 17.3707 4.86683 16.3938L3.97696 4.82547M16.023 4.82547C15.0677 4.6812 14.1013 4.57071 13.125 4.49527M3.125 4.96358C3.40798 4.91456 3.69198 4.86851 3.97696 4.82547M3.97696 4.82547C4.93231 4.6812 5.89874 4.57071 6.875 4.49527M13.125 4.49527V3.73182C13.125 2.74902 12.3661 1.92853 11.3838 1.8971C10.9244 1.8824 10.463 1.875 10 1.875C9.53696 1.875 9.07565 1.8824 8.61618 1.8971C7.63388 1.92853 6.875 2.74902 6.875 3.73182V4.49527M13.125 4.49527C12.0938 4.41558 11.0516 4.375 10 4.375C8.94836 4.375 7.9062 4.41558 6.875 4.49527'
      stroke='#6B7280' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'
    />
  </svg>
)

export const IconBookGreen = () => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M10.7061 5.01651C9.30725 4.12106 7.64379 3.60156 5.85998 3.60156C4.80931 3.60156 3.79926 3.78189 2.86004 4.11386C2.5834 4.21164 2.39844 4.47318 2.39844 4.76659V17.9204C2.39844 18.1452 2.50752 18.3559 2.69102 18.4857C2.87451 18.6154 3.10956 18.6481 3.32145 18.5732C4.11454 18.2929 4.96866 18.14 5.85998 18.14C7.70153 18.14 9.38913 18.7929 10.7061 19.8807V5.01651Z'
      fill='#278015'
    />
    <path
      d='M12.0907 19.8807C13.4077 18.7929 15.0953 18.14 16.9369 18.14C17.8282 18.14 18.6823 18.2929 19.4754 18.5732C19.6873 18.6481 19.9224 18.6154 20.1059 18.4857C20.2894 18.3559 20.3984 18.1452 20.3984 17.9204V4.76659C20.3984 4.47318 20.2135 4.21164 19.9368 4.11386C18.9976 3.78189 17.9876 3.60156 16.9369 3.60156C15.1531 3.60156 13.4896 4.12106 12.0907 5.01651V19.8807Z'
      fill='#278015'
    />
  </svg>
)
export const IconUserGold = () => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd' clipRule='evenodd'
      d='M18.818 14.1235C18.2016 13.4088 17.1428 13.4456 16.3149 13.8987C15.0338 14.6 13.5635 14.9986 12 14.9986C10.4365 14.9986 8.96618 14.6 7.68505 13.8987C6.85717 13.4456 5.79841 13.4088 5.182 14.1235C3.82222 15.7 3 17.7533 3 19.9986V20.9986C3 22.1032 3.89543 22.9986 5 22.9986H19C20.1046 22.9986 21 22.1032 21 20.9986V19.9986C21 17.7533 20.1778 15.7 18.818 14.1235Z'
      fill='#D99606'
    />
    <path
      d='M17 6C17 8.76142 14.7614 11 12 11C9.23858 11 7 8.76142 7 6C7 3.23858 9.23858 1 12 1C14.7614 1 17 3.23858 17 6Z'
      fill='#D99606'
    />
  </svg>

)
export const IconUserRed = () => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd' clipRule='evenodd'
      d='M18.818 14.1235C18.2016 13.4088 17.1428 13.4456 16.3149 13.8987C15.0338 14.6 13.5635 14.9986 12 14.9986C10.4365 14.9986 8.96618 14.6 7.68505 13.8987C6.85717 13.4456 5.79841 13.4088 5.182 14.1235C3.82222 15.7 3 17.7533 3 19.9986V20.9986C3 22.1032 3.89543 22.9986 5 22.9986H19C20.1046 22.9986 21 22.1032 21 20.9986V19.9986C21 17.7533 20.1778 15.7 18.818 14.1235Z'
      fill='#B91C1F'
    />
    <path
      d='M17 6C17 8.76142 14.7614 11 12 11C9.23858 11 7 8.76142 7 6C7 3.23858 9.23858 1 12 1C14.7614 1 17 3.23858 17 6Z'
      fill='#B91C1F'
    />
  </svg>

)
export const IconDiamondLight = ({ ...rest }) => (
  <svg {...rest} width='23' height='18' viewBox='0 0 23 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M5.49902 6.23242L9.83887 16.1602L0.895508 6.23242H5.49902Z' fill='#0876B1' stroke='white'
          strokeWidth='0.7' />
    <path d='M5.32812 5.53125H0.882812L4.74707 1.14453L5.32812 5.53125Z' fill='#0876B1' stroke='white'
          strokeWidth='0.7' />
    <path d='M10.2041 0.689453L5.97656 5.11328L5.38965 0.689453H10.2041Z' fill='#0876B1' stroke='white'
          strokeWidth='0.7' />
    <path d='M15.7842 6.23242L11.0225 17.125L6.26074 6.23242H15.7842Z' fill='#0876B1' stroke='white'
          strokeWidth='0.7' />
    <path d='M16.6553 0.689453L16.0684 5.11328L11.8418 0.689453H16.6553Z' fill='#0876B1' stroke='white'
          strokeWidth='0.7' />
    <path d='M21.165 5.53125H16.7197L17.3008 1.14551L21.165 5.53125Z' fill='#0876B1' stroke='white'
          strokeWidth='0.7' />
    <path d='M21.1494 6.23242L12.2051 16.1602L16.5459 6.23242H21.1494Z' fill='#0876B1' stroke='white'
          strokeWidth='0.7' />
    <path d='M15.5 5.5332H6.54492L11.0225 0.84668L15.5 5.5332Z' fill='#0876B1' stroke='white' strokeWidth='0.7' />
    <path
      d='M10.7021 17.293L10.8467 17.6221C10.7245 17.5884 10.6117 17.5244 10.5254 17.4287L9.63477 16.4395L10.1758 16.0898L10.7021 17.293ZM12.4102 16.4395L11.5205 17.4287C11.4342 17.5244 11.3215 17.5884 11.1992 17.6221L11.3438 17.293L11.8691 16.0898L12.4102 16.4395Z'
      fill='#0876B1' stroke='white' strokeWidth='0.7' />
  </svg>

)

export const IconStar = () => (
  <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <mask id='mask0_32232_4795' style={{ maskType: 'alpha' }} maskUnits='userSpaceOnUse' x='1' y='0' width='12' height='12'>
      <path
        d='M6.28834 1.10996C6.45914 0.699318 7.04086 0.699318 7.21166 1.10996L8.41812 4.01063C8.49012 4.18375 8.65292 4.30203 8.83982 4.31702L11.9713 4.56807C12.4147 4.60361 12.5944 5.15686 12.2567 5.4462L9.87077 7.48996C9.72838 7.61194 9.66619 7.80332 9.70969 7.9857L10.4386 11.0415C10.5418 11.4741 10.0712 11.8161 9.69164 11.5842L7.01063 9.94669C6.85062 9.84896 6.64938 9.84896 6.48937 9.94669L3.80836 11.5842C3.42881 11.8161 2.95819 11.4741 3.06138 11.0415L3.79031 7.9857C3.83381 7.80332 3.77162 7.61194 3.62923 7.48996L1.24335 5.4462C0.905577 5.15686 1.08534 4.60361 1.52867 4.56807L4.66018 4.31702C4.84708 4.30203 5.00988 4.18375 5.08188 4.01063L6.28834 1.10996Z'
        fill='#1F2937'
      />
    </mask>
    <g mask='url(#mask0_32232_4795)'>
      <rect width='13.5' height='12.6' fill='#FFBE17' />
    </g>
  </svg>
)